export enum ACCOUNT_STEPS {
  LOGIN_SELECTION,
  EMAIL,
  PASSWORD,
  FORGOT_PASSWORD,
  SEND_PASSWORD_CREATION_LINK
}
